import type { ContactExpandOpts } from '@condo/domain';

export const contactDetailExpand = {
    select: [
        'contactId',
        'salutation',
        'academicRank',
        'userId',
        'firstname',
        'lastname',
        'contactType',
        'phoneNumber',
        'email',
        'homepageUrl',
        'birthday',
        'subCompany',
        'shouldHideForExternals',
    ],
    expand: {
        avatarMediaFile: {
            select: ['mediaFileId', 'path'],
            expand: {
                variants: {
                    select: ['mediaFileId', 'path', 'variant'],
                },
            },
        },
        location: {
            select: ['locationId', 'longitude', 'latitude', 'street', 'houseNumber', 'zipcode', 'city', 'quarter', 'addressLine2'],
        },
        employment: {
            select: ['contactPersonId', 'companyId', 'companyRole', 'isMainContact', 'companyTeam'],
            expand: {
                company: {
                    select: ['companyId', 'name'],
                },
            },
        },
        accounting: {
            select: [
                'accountingId',
                'contactPersonId',
                'defaultCostType',
                'datevCreditorId',
                'datevDebtorId',
                'datevBookKeepingAccount',
                'isNetSuiteCreditor',
                'taxId',
                'vatId',
            ],
        },
        contactRelation: {
            select: ['contactRelationId', 'estateId', 'mfhId'],
        },
    },
} as ContactExpandOpts;
